var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGooglePlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 189,
    height: 56,
    viewBox: "0 0 189 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 188,
    height: 55,
    rx: 11.5,
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 188,
    height: 55,
    rx: 11.5,
    stroke: "#A6A6A6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95.3906 30.4528C92.0978 30.4528 89.414 32.9574 89.414 36.407C89.414 39.8356 92.0978 42.3612 95.3906 42.3612C98.6848 42.3612 101.369 39.8356 101.369 36.407C101.367 32.9574 98.6834 30.4528 95.3906 30.4528ZM95.3906 40.0176C93.586 40.0176 92.0306 38.5294 92.0306 36.4084C92.0306 34.265 93.5874 32.7992 95.3906 32.7992C97.1952 32.7992 98.7506 34.265 98.7506 36.4084C98.7506 38.528 97.1952 40.0176 95.3906 40.0176ZM82.351 30.4528C79.0582 30.4528 76.3744 32.9574 76.3744 36.407C76.3744 39.8356 79.0582 42.3612 82.351 42.3612C85.6452 42.3612 88.329 39.8356 88.329 36.407C88.329 32.9574 85.6452 30.4528 82.351 30.4528ZM82.351 40.0176C80.5464 40.0176 78.991 38.5294 78.991 36.4084C78.991 34.265 80.5478 32.7992 82.351 32.7992C84.1556 32.7992 85.711 34.265 85.711 36.4084C85.7124 38.528 84.1556 40.0176 82.351 40.0176ZM66.8418 32.2812V34.8068H72.887C72.7064 36.2278 72.2332 37.2652 71.5108 37.9862C70.6316 38.8654 69.2554 39.8356 66.8418 39.8356C63.1206 39.8356 60.2114 36.8354 60.2114 33.1142C60.2114 29.393 63.1206 26.3928 66.8418 26.3928C68.8494 26.3928 70.3152 27.1824 71.3974 28.1974L73.1796 26.4152C71.6676 24.9718 69.6614 23.8672 66.8418 23.8672C61.7444 23.8672 57.459 28.0168 57.459 33.1142C57.459 38.2116 61.7444 42.3612 66.8418 42.3612C69.5928 42.3612 71.669 41.4582 73.2916 39.767C74.9604 38.0982 75.4798 35.7518 75.4798 33.8576C75.4798 33.2724 75.435 32.7306 75.344 32.2798H66.8418V32.2812ZM130.273 34.2426C129.777 32.9126 128.265 30.4528 125.176 30.4528C122.108 30.4528 119.559 32.8664 119.559 36.407C119.559 39.7446 122.086 42.3612 125.468 42.3612C128.197 42.3612 129.776 40.6924 130.431 39.7222L128.401 38.3684C127.725 39.361 126.8 40.0148 125.468 40.0148C124.138 40.0148 123.19 39.4058 122.581 38.2102L130.543 34.9174L130.273 34.2426ZM122.153 36.2278C122.086 33.9262 123.935 32.7544 125.267 32.7544C126.304 32.7544 127.183 33.2738 127.477 34.0172L122.153 36.2278ZM115.681 42.0014H118.296V24.5H115.681V42.0014ZM111.394 31.7842H111.304C110.718 31.0842 109.589 30.4528 108.17 30.4528C105.192 30.4528 102.463 33.0694 102.463 36.4308C102.463 39.7684 105.192 42.3626 108.17 42.3626C109.591 42.3626 110.718 41.7312 111.304 41.0102H111.394V41.867C111.394 44.1448 110.176 45.3628 108.215 45.3628C106.613 45.3628 105.62 44.2134 105.214 43.2432L102.937 44.191C103.59 45.7688 105.326 47.7092 108.215 47.7092C111.282 47.7092 113.876 45.9046 113.876 41.5058V30.8154H111.395V31.7842H111.394ZM108.395 40.0176C106.591 40.0176 105.08 38.5056 105.08 36.4308C105.08 34.3322 106.591 32.7992 108.395 32.7992C110.176 32.7992 111.575 34.3322 111.575 36.4308C111.575 38.5056 110.176 40.0176 108.395 40.0176ZM142.529 24.5H136.269V42.0014H138.88V35.371H142.527C145.422 35.371 148.27 33.2752 148.27 29.9362C148.27 26.5972 145.424 24.5 142.529 24.5ZM142.596 32.935H138.88V26.936H142.596C144.549 26.936 145.658 28.553 145.658 29.9362C145.658 31.2914 144.549 32.935 142.596 32.935ZM158.741 30.422C156.849 30.422 154.891 31.255 154.08 33.1016L156.398 34.069C156.894 33.1016 157.818 32.7852 158.785 32.7852C160.136 32.7852 161.51 33.5958 161.532 35.0364V35.217C161.059 34.9468 160.045 34.5422 158.808 34.5422C156.309 34.5422 153.764 35.9156 153.764 38.4818C153.764 40.824 155.813 42.3318 158.109 42.3318C159.865 42.3318 160.834 41.5436 161.441 40.6196H161.531V41.9706H164.054V35.2604C164.055 32.1552 161.734 30.422 158.741 30.422ZM158.424 40.0134C157.57 40.0134 156.376 39.585 156.376 38.5266C156.376 37.1756 157.863 36.6576 159.147 36.6576C160.293 36.6576 160.835 36.9054 161.532 37.2428C161.329 38.8654 159.933 40.0134 158.424 40.0134ZM173.24 30.8042L170.246 38.3922H170.156L167.048 30.8042H164.234L168.895 41.4092L166.238 47.3088H168.962L176.145 30.8042H173.24ZM149.712 42.0014H152.323V24.5H149.712V42.0014Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.385 14.3385C66.385 15.5117 66.0378 16.4455 65.342 17.1427C64.5524 17.9715 63.522 18.3859 62.2564 18.3859C61.044 18.3859 60.0122 17.9659 59.1652 17.1259C58.3168 16.2845 57.8926 15.2429 57.8926 13.9997C57.8926 12.7551 58.3168 11.7135 59.1652 10.8735C60.0122 10.0321 61.044 9.61211 62.2564 9.61211C62.8584 9.61211 63.4338 9.72971 63.9798 9.96351C64.5272 10.1987 64.9654 10.5109 65.293 10.9015L64.5552 11.6407C63.9994 10.9757 63.2336 10.6439 62.255 10.6439C61.3702 10.6439 60.6058 10.9547 59.9604 11.5763C59.315 12.1979 58.993 13.0057 58.993 13.9983C58.993 14.9909 59.315 15.7987 59.9604 16.4203C60.6058 17.0419 61.3702 17.3527 62.255 17.3527C63.193 17.3527 63.9756 17.0405 64.6014 16.4147C65.0074 16.0073 65.2426 15.4403 65.3056 14.7137H62.255V13.7043H66.3248C66.3668 13.9241 66.385 14.1355 66.385 14.3385Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8391 10.8302H69.0143V13.493H72.4639V14.5024H69.0143V17.1652H72.8391V18.1984H67.9349V9.79839H72.8391V10.8302Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3903 18.1984H76.311V10.8302H73.9646V9.79839H79.7367V10.8302H77.3903V18.1984Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M83.9129 18.1984V9.79839H84.9923V18.1984H83.9129Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7791 18.1984H88.6997V10.8302H86.3533V9.79839H92.1255V10.8302H89.7791V18.1984Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M103.052 17.1134C102.226 17.9618 101.2 18.386 99.9722 18.386C98.7444 18.386 97.7182 17.9618 96.8936 17.1134C96.0676 16.265 95.656 15.2262 95.656 13.9984C95.656 12.7706 96.0676 11.7318 96.8936 10.8834C97.7182 10.035 98.7444 9.60938 99.9722 9.60938C101.193 9.60938 102.218 10.0364 103.047 10.889C103.875 11.7416 104.29 12.7776 104.29 13.9984C104.29 15.2262 103.877 16.265 103.052 17.1134ZM97.6902 16.4092C98.3118 17.0392 99.072 17.3528 99.9722 17.3528C100.872 17.3528 101.634 17.0378 102.254 16.4092C102.876 15.7792 103.188 14.9756 103.188 13.9984C103.188 13.0212 102.876 12.2176 102.254 11.5876C101.634 10.9576 100.872 10.644 99.9722 10.644C99.072 10.644 98.3118 10.959 97.6902 11.5876C97.07 12.2176 96.7578 13.0212 96.7578 13.9984C96.7578 14.9756 97.07 15.7792 97.6902 16.4092Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M105.805 18.1984V9.79839H107.118L111.2 16.3322H111.246L111.2 14.7138V9.79839H112.28V18.1984H111.153L106.881 11.3468H106.835L106.881 12.9652V18.1984H105.805Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M66.385 14.3385C66.385 15.5117 66.0378 16.4455 65.342 17.1427C64.5524 17.9715 63.522 18.3859 62.2564 18.3859C61.044 18.3859 60.0122 17.9659 59.1652 17.1259C58.3168 16.2845 57.8926 15.2429 57.8926 13.9997C57.8926 12.7551 58.3168 11.7135 59.1652 10.8735C60.0122 10.0321 61.044 9.61211 62.2564 9.61211C62.8584 9.61211 63.4338 9.72971 63.9798 9.96351C64.5272 10.1987 64.9654 10.5109 65.293 10.9015L64.5552 11.6407C63.9994 10.9757 63.2336 10.6439 62.255 10.6439C61.3702 10.6439 60.6058 10.9547 59.9604 11.5763C59.315 12.1979 58.993 13.0057 58.993 13.9983C58.993 14.9909 59.315 15.7987 59.9604 16.4203C60.6058 17.0419 61.3702 17.3527 62.255 17.3527C63.193 17.3527 63.9756 17.0405 64.6014 16.4147C65.0074 16.0073 65.2426 15.4403 65.3056 14.7137H62.255V13.7043H66.3248C66.3668 13.9241 66.385 14.1355 66.385 14.3385Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8391 10.8302H69.0143V13.493H72.4639V14.5024H69.0143V17.1652H72.8391V18.1984H67.9349V9.79839H72.8391V10.8302Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3903 18.1984H76.311V10.8302H73.9646V9.79839H79.7367V10.8302H77.3903V18.1984Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M83.9129 18.1984V9.79839H84.9923V18.1984H83.9129Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7791 18.1984H88.6997V10.8302H86.3533V9.79839H92.1255V10.8302H89.7791V18.1984Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M103.052 17.1134C102.226 17.9618 101.2 18.386 99.9722 18.386C98.7444 18.386 97.7182 17.9618 96.8936 17.1134C96.0676 16.265 95.656 15.2262 95.656 13.9984C95.656 12.7706 96.0676 11.7318 96.8936 10.8834C97.7182 10.035 98.7444 9.60938 99.9722 9.60938C101.193 9.60938 102.218 10.0364 103.047 10.889C103.875 11.7416 104.29 12.7776 104.29 13.9984C104.29 15.2262 103.877 16.265 103.052 17.1134ZM97.6902 16.4092C98.3118 17.0392 99.072 17.3528 99.9722 17.3528C100.872 17.3528 101.634 17.0378 102.254 16.4092C102.876 15.7792 103.188 14.9756 103.188 13.9984C103.188 13.0212 102.876 12.2176 102.254 11.5876C101.634 10.9576 100.872 10.644 99.9722 10.644C99.072 10.644 98.3118 10.959 97.6902 11.5876C97.07 12.2176 96.7578 13.0212 96.7578 13.9984C96.7578 14.9756 97.07 15.7792 97.6902 16.4092Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M105.805 18.1984V9.79839H107.118L111.2 16.3322H111.246L111.2 14.7138V9.79839H112.28V18.1984H111.153L106.881 11.3468H106.835L106.881 12.9652V18.1984H105.805Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_11202_15533)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6101 10.5514C14.2027 10.9826 13.9619 11.6518 13.9619 12.5184V43.4808C13.9619 44.3488 14.2027 45.0166 14.6101 45.4478L14.7137 45.5486L32.0583 28.204V27.9996V27.7952L14.7137 10.4492L14.6101 10.5514Z",
    fill: "url(#paint0_linear_11202_15533)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8392 33.9898L32.0586 28.2064V28.002V27.7976L37.8406 22.0156L37.9708 22.0898L44.821 25.9818C46.7768 27.0934 46.7768 28.912 44.821 30.025L37.9708 33.917L37.8392 33.9898Z",
    fill: "url(#paint1_linear_11202_15533)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_11202_15533)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.9708 33.9136L32.0572 28L14.6104 45.4482C15.2544 46.1314 16.3198 46.2154 17.5196 45.535L37.9708 33.9136Z",
    fill: "url(#paint2_linear_11202_15533)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M37.9708 22.0866L17.5196 10.4666C16.3198 9.7848 15.2544 9.8702 14.6104 10.5534L32.0586 28.0016L37.9708 22.0866Z",
    fill: "url(#paint3_linear_11202_15533)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_11202_15533",
    x: 13.9619,
    y: 9.99609,
    width: 32.3262,
    height: 36.0078,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_11202_15533"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_11202_15533",
    result: "effect2_innerShadow_11202_15533"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_11202_15533",
    x: 14.6104,
    y: 28,
    width: 23.3604,
    height: 18.0039,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_11202_15533"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11202_15533",
    x1: 30.5208,
    y1: 12.1908,
    x2: 7.02604,
    y2: 35.6856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_11202_15533",
    x1: 47.3669,
    y1: 28.002,
    x2: 13.4926,
    y2: 28.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_11202_15533",
    x1: 34.7593,
    y1: 31.2115,
    x2: 2.89741,
    y2: 63.0734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_11202_15533",
    x1: 10.2163,
    y1: 0.246319,
    x2: 24.4435,
    y2: 14.4735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlay);
export default __webpack_public_path__ + "static/media/google-play.11918f54092c74a2e64da54c8fb01a26.svg";
export { ForwardRef as ReactComponent };